import React,{useEffect} from 'react';
import Header from '../../components/Header';
import SignUpMain from './SignUpMain';
import Footer from '../../components/Footer';


const SignUp = () => {
        useEffect(() => {
        document.title = "Membership Registration | Society of Aquaculture Professionals";
      }, []);
  return (
    <>
      <Header/>

      <SignUpMain />

      <Footer/>

    </>
  );
};

export default SignUp;
